import { _ } from "i18n";
import type { VideoUploadLog } from "libs/apiClient";
import DatagridV2, { type SimpleColumn } from "ui-kit/src/Datagrid/DatagridV2";
import { formatDateTime } from "./functions";

interface MetadataLogTableProps {
	logs?: VideoUploadLog[];
	refreshClick: () => void;
}

export function MetadataLogTable({ logs, refreshClick }: MetadataLogTableProps) {
	const columns: SimpleColumn<VideoUploadLog>[] = [
		{
			id: "timestamp",
			key: "timestamp",
			header: () => "Date & time",
			cell: (value, row) => <div className="dateTimeCell">{formatDateTime(row.timestamp) ?? "-"}</div>,
		},
		{
			id: "status",
			key: "status",
			header: () => "Event name",
			cell: (value, row) => <div className="statusCell">{row.status?.replace(/_/g, " ") ?? "-"}</div>,
		},
		{
			id: "message",
			key: "message",
			header: () => "message",
			cell: (value, row) => <div className="messageCell wrapCell">{row.message ?? "-"}</div>,
		},
	];
	return (
		<div className="log-container">
			<h2 style={{ display: "flex", justifyContent: "space-between" }}>
				Log of events
				<div className="refetchButton" onClick={refreshClick}>
					<span className="icon-new icon-admin-syc icon-white icon-24" />
					<div className="buttonText">{_("label.refresh")}</div>
				</div>
			</h2>

			<div className="logtable-container">
				<DatagridV2
					simpleColumns={columns}
					data={logs ?? []}
					noResults="no logs available"
					pageCount={1}
					pagination={{ pageIndex: 0, pageSize: 10 }}
					setPagination={() => {}}
				/>
			</div>
		</div>
	);
}
